import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    transition: 'all 100ms ease-in-out',
  },
  child: {
    marginTop: 15,
    backgroundColor:
      theme.palette.type === 'dark' ? '#fff' : theme.palette.primary.secondary,
    width: '60%',
    borderRadius: theme.shape.borderRadius * 2,
    borderBottomLeftRadius: 0,
    padding: 15,
    paddingBottom: 12,
    '& h4': {
      color: theme.palette.primary.main,
      borderBottom: `1px solid ${theme.palette.hover2}`,
      paddingBottom: 5,
      marginBottom: 7,
    },
    '& p': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.primary.secondary
          : '#fff',
    },
    '@media (min-width: 1441px)': {
      width: '45%',
    },
  },
  actions: {
    marginTop: 15,
    marginLeft: 5,
    width: 35,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  bookmarked: {
    marginTop: 22,
    marginLeft: 14,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    transition: 'all 100ms ease-in-out',
  },
  picture: {
    margin: 0,
    padding: 0,
    marginTop: 10,
    width: '100%',
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
  },
  location: {
    margin: 0,
    padding: 0,
    marginTop: 25,
    marginBottom: 8,
    width: '100%',
    minHeight: 150,
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    backgroundImage: `url('/map-thumbnail.png')`,
    backgroundSize: 'cover',
  }
}))

export default useStyles
